import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { IRequestAFactoryQuoteBody, MasterData, IRequestAFactoryQuoteSkill, IUser, IFactoryQuoteLbl } from '../../../../core/models';
import { QuoteService } from '../../../../core/services/quote.service';
import { UserService } from '../../../../core/services/user.service';
import { HelperService } from '../../../../core/services/helper.service';
import { LanguageTranslationService } from '../../../../core/services/language-translation.service';
import { FileInfo, FileRestrictions, SuccessEvent } from '@progress/kendo-angular-upload';
import { formatDate, CurrencyPipe } from '@angular/common';
@Component({
  selector: 'app-factory-quote-request',
  templateUrl: './factory-quote-request.component.html',
  styleUrls: ['./factory-quote-request.component.scss']
})
export class FactoryQuoteRequestComponent implements OnInit {
  constructor(private formBuilder: FormBuilder, private quoteService: QuoteService, private helperService: HelperService, private userService: UserService, private router: Router, private languageTranslationService: LanguageTranslationService) { }
  factoryQuoteRequest: FormGroup;
  skills = new FormArray([]);
  showCancelConfirmation: boolean;
  public confirmWindowOpened = false;
  public saveInProcess: boolean;
  factoryQuoteTxt: IFactoryQuoteLbl;
  isSuccess: boolean;
  isFailed: boolean;
  uploadedfileNames: string[] = [];
  uploadedPathForQuoteFile: string[] = [];
  fileRestrictions: FileRestrictions = {
    allowedExtensions: [".jpg", ".png", ".jfif", ".pdf", ".doc", ".docx", ".csv", ".xls", ".xlsx"],
  };
  myFiles: Array<FileInfo> = [];
  ngOnInit() {
    this.loadLanguageTranslationData();
    this.minimumDate();
    this.skills.push(this.addProductFormGroup());
    this.factoryQuoteRequest = this.formBuilder.group({
      quoteRequestDate: new FormControl(),
      isReceiveEmail: new FormControl(),
      email: new FormControl(),//Need to check validation
      confirmEmail: new FormControl(),
      contactName: new FormControl(),
      jobName: new FormControl(),
      productType: new FormControl(),
      infill: new FormControl(),
      finishType: new FormControl(),
      glazing: new FormControl(),
      color: new FormControl(),
      paintFinishDropDown: new FormControl(),
      glassSupplier: new FormControl(),
      glassSpecMakeup: new FormControl(),
      screens: new FormControl(),
      mesh: new FormControl(),
      hardware: new FormControl(),
      paintFinishInput: new FormControl(),
      anodizeColor: new FormControl(),
      specialFeatures: new FormControl(),
      specifyMeshType: new FormControl(),
      specifyHardware: new FormControl(),
      muntins: new FormControl(),
      windload: new FormControl(),
      pieceReceptor: new FormControl(),
      sill: new FormControl(),
      panning: new FormControl(),
      interiorTrim: new FormControl(),
      mullions: new FormControl(),
      miscellaneous: new FormControl(),
      strapAnchors: new FormControl(),
      projectComment: new FormControl(),
      // markType: new FormControl(),
      // quantity: new FormControl(),
      // size: new FormControl(),
      // description: new FormControl(),

    })
    this.bindDropdownData();
    this.isSuccess = false;
    this.isFailed = false;
  }
  addProductFormGroup(): FormGroup {
    const group = new FormGroup({
      markType: new FormControl(''),
      quantity: new FormControl(''),
      size: new FormControl(''),
      description: new FormControl('')
    });
    return group;
  }
  addSkillButtonClick(): void {
    this.skills.push(this.addProductFormGroup());
  }
  removeskill(i: number): void {
    this.skills.removeAt(i);
  }
  protected get loggedInUser(): IUser {
    return this.userService.readUserObject;
  }
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "customerNameLbl" },
      { controlName: "customerNumberLbl" },
      { controlName: "originDateLbl" },
      { controlName: "quoteRequestDateLbl" },
      { controlName: "emailConfirmationLbl" },
      { controlName: "emailLbl" },
      { controlName: "confirmEmailLbl" },
      { controlName: "contactNameLbl" },
      { controlName: "jobNameLbl" },
      { controlName: "productTypeLbl" },
      { controlName: "infillLbl" },
      { controlName: "finishTypeLbl" },
      { controlName: "glazingLbl" },
      { controlName: "muntinsLbl" },
      { controlName: "colorLbl" },
      { controlName: "paintFinishLbl" },
      { controlName: "glassSupplierLbl" },
      { controlName: "glassSpecMakeupLbl" },
      { controlName: "screensLbl" },
      { controlName: "meshLbl" },
      { controlName: "hardwareLbl" },
      { controlName: "paintFinishInputLbl" },
      { controlName: "anodizeColorLbl" },
      { controlName: "specialFeaturesLbl" },
      { controlName: "meshTypeLbl" },
      { controlName: "specifyHardwareLbl" },
      { controlName: "ordewindloadLblrTypeLbl" },
      { controlName: "windloadLbl" },
      { controlName: "pieceReceptorLbl" },
      { controlName: "sillLbl" },
      { controlName: "panningLbl" },
      { controlName: "interiorTrimLbl" },
      { controlName: "mullionsLbl" },
      { controlName: "miscellaneousLbl" },
      { controlName: "strapAnchorsLbl" },
      { controlName: "projectCommentLbl" },
      { controlName: "quantityLbl" },
      { controlName: "sizeLbl" },
      { controlName: "descriptionLbl" },
      { controlName: "attachmentLblLbl" },
      { controlName: "submitButtonLbl" },
      { controlName: "cancelLbl" },
      { controlName: "submitSuccessLbl" },
      { controlName: "submitFailedLbl" },
      { controlName: "noLbl" },
      { controlName: "yesLbl" },
      { controlName: "cancelConfirmLbl" },
      { controlName: "quoteSubmittedLbl" },
      { controlName: "submittedForProcessingLbl" },
      { controlName: "thanksLbl" },
      { controlName: "actioneNeededLbl" },
      { controlName: "contactInfoLbl" },
      { controlName: "returnToInHouseQuoteLbl" },
      { controlName: "addNewQuoteRequestLbl" },
      { controlName: "addNewTitle" },
      { controlName: "deleteTitle" },
      { controlName: "confirmTitleLbl" },
      { controlName: "invalidEmailLbl" },
      { controlName: "confirmEmailMatchLbl" },
    ];
    const componentName = "factoryQuote";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.factoryQuoteTxt = response[response.length - 1];
      console.log(response);
    }
  }
  //#endregion
  //#region dynamic labels

  protected factoryQuote = {
    customerNameLbl: "Customer Name:",
    customerNameText: this.loggedInUser.customerName,
    customerNumberLbl: "Customer Number:",
    customerNumberText: this.loggedInUser.customerNumber,
    originDateLbl: "Origination Date:",
    originDateText: new Date(),
    quoteRequestDateLbl: "Quote Request Date",
    emailConfirmationLbl: "Would you like to recieve an email confirmation of this quote ?",
    emailLbl: 'Email',
    confirmEmailLbl: 'Confirm Email',
    contactNameLbl: 'Contact Name',
    jobNameLbl: 'Job Name',
    productTypeLbl: 'Product Type',
    infillLbl: 'Infill',
    finishTypeLbl: 'Finish Type',
    glazingLbl: 'Glazing',
    muntinsLbl: 'Muntins',
    colorLbl: 'Color',
    paintFinishLbl: 'Paint Finish',
    glassSupplierLbl: 'Glass Supplier',
    glassSpecMakeupLbl: 'Glass Spec Makeup',
    screensLbl: 'Screens',
    meshLbl: 'Mesh',
    hardwareLbl: 'Hardware',
    paintFinishInputLbl: 'Provide Paint Finish',
    anodizeColorLbl: 'Color',
    specialFeaturesLbl: 'Special Features',
    meshTypeLbl: 'Please Specify Mesh Type',
    specifyHardwareLbl: 'Please Specify Hardware',

    windloadLbl: 'Windload/PSF',
    pieceReceptorLbl: 'Piece Receptor',
    sillLbl: 'Sill',
    panningLbl: 'Panning',
    interiorTrimLbl: 'Interior Trim',
    mullionsLbl: 'Mullions',
    miscellaneousLbl: 'Miscellaneous',
    strapAnchorsLbl: 'Strap Anchors',
    projectCommentLbl: 'Project Related Comments',

    markTypeLbl: 'Mark Type',
    quantityLbl: 'Quantity',
    sizeLbl: 'Size (Width x Height)',
    descriptionLbl: 'Description',

    attachmentLblLbl: 'Attachment',
    submitButtonLbl: 'Submit',
    cancelLbl: 'Cancel',
    productTypeDescription: "",
    submitSuccessLbl: "Submitted successfully ",
    submitFailedLbl: "Submit Failed! ",
    noLbl: "No",
    yesLbl: "Yes",
    cancelConfirmLbl: "Are you sure you want to cancel?",
    quoteSubmittedLbl: "New Quote Request Submitted",
    submittedForProcessingLbl: "Your Kawneer Window Quotation request has been submitted for processing.",
    thanksLbl: "Thank you for choosing Kawneer!",
    actioneNeededLbl: "Contact us if corrective action is needed.",
    contactInfoLbl: "Contact Information",
    responseEmail: "KawneerDirect@Arconic.com", //Hard coded popup email response 
    returnToInHouseQuoteLbl: "Return To In-House Quotes",
    addNewQuoteRequestLbl: "Add New Quote Request",
    invalidEmailLbl: "Email address is invalid",
    confirmEmailMatchLbl: "Email and Confirm Email must be match.",
    addNewTitle: "Add New",
    deleteTitle: "Delete",
    confirmTitleLbl: "Please Confirm",
    isEmailFormatInValid: false,
    isInvalidEmail: false,
    isemailNotMatched: false,
    isInvalidConfirmEmail: false,
    isSubmitted: false,
    isReceiveEmailChecked: false,
    //add more labels here
  }
  //#endregion
  //#region cancel button funactionality
  cancel() {
    //show popup confirmation
    this.showCancelConfirmation = true;
  }
  confirmCancel(isYes: boolean) {
    if (isYes) {
      this.router.navigate(["/manage-quote"]);
    } else {
      this.showCancelConfirmation = false;
    }
  }
  //#endregion
  //handles switch change event

  showEmail() {
    this.factoryQuote.isReceiveEmailChecked = !this.factoryQuote.isReceiveEmailChecked;
  }

  //#region form submit operations
  factoryQuoteSubmit() {
    this.isSuccess = false;
    this.isFailed = false;
    if (!this.validatefactoryQuoteForm()) {
      return;
    }
    console.log(this.factoryQuoteRequest.controls);
    console.log(<FormGroup>this.skills.controls[0])
    //#region Add New Product Skills
    var skill: IRequestAFactoryQuoteSkill;
    var skills: IRequestAFactoryQuoteSkill[] = [];
    this.skills.controls.forEach(f => {
      var fgSkill = <FormGroup>f;
      skill = {
        markType: fgSkill.controls.markType.value,
        quantity: fgSkill.controls.quantity.value,
        size: fgSkill.controls.size.value,
        description: fgSkill.controls.description.value
      };
      skills.push(skill);
    });
    console.log(JSON.stringify(skills));
    //#endregion
    const controls = this.factoryQuoteRequest.controls;
    debugger;
    const body = {

      quoteRequestDate: formatDate(controls.quoteRequestDate.value, 'MM/dd/yyyy', 'en'),
      isReceiveEmail: controls.isReceiveEmail.value ? controls.isReceiveEmail.value : false,
      email: controls.email.value,
      confirmEmail: controls.confirmEmail.value,
      contactName: controls.contactName.value,
      jobName: controls.jobName.value,
      productType: controls.productType.value ? controls.productType.value.name : "",
      infill: controls.infill.value ? controls.infill.value.name : "",
      finishType: controls.finishType.value ? controls.finishType.value.name : "",
      glazing: controls.glazing.value ? controls.glazing.value.name : "",
      color: controls.color.value ? controls.color.value.name : "",
      paintFinishDropDown: controls.paintFinishDropDown.value ? controls.paintFinishDropDown.value.name : "",
      glassSupplier: controls.glassSupplier.value ? controls.glassSupplier.value.name : "",
      glassSpecMakeup: controls.glassSpecMakeup.value,
      screens: controls.screens.value ? controls.screens.value.name : "",
      mesh: controls.mesh.value ? controls.mesh.value.name : "",
      hardware: controls.hardware.value ? controls.hardware.value.name : "",
      paintFinishInput: controls.paintFinishInput.value,
      anodizeColor: controls.anodizeColor.value ? controls.anodizeColor.value.name : "",
      specialFeatures: controls.specialFeatures.value,
      specifyMeshType: controls.specifyMeshType.value,
      specifyHardware: controls.specifyHardware.value,
      muntins: controls.muntins.value ? controls.muntins.value.name : "",
      windload: controls.windload.value,
      pieceReceptor: controls.pieceReceptor.value,
      sill: controls.sill.value,
      panning: controls.panning.value,
      interiorTrim: controls.interiorTrim.value,
      mullions: controls.mullions.value,
      miscellaneous: controls.miscellaneous.value,
      strapAnchors: controls.strapAnchors.value,
      projectComment: controls.projectComment.value,
      skills: skills,
      filePaths: this.uploadedPathForQuoteFile
    }
    this.saveInProcess = true;
    this.quoteService.requestAFactoryQuote(body as IRequestAFactoryQuoteBody).subscribe((response: IRequestAFactoryQuoteBody) => {
      this.saveInProcess = false;

      if (response) {
        //do something
        this.isSuccess = true;
        this.factoryQuoteRequest.reset();
        this.skills.reset();
        this.myFiles = [];
        this.uploadedPathForQuoteFile = [];
        this.factoryQuote.isReceiveEmailChecked = false;
      } else {
        //do something
        this.isFailed = true;
      }
    }, error => { this.saveInProcess = false; this.isFailed = true; })
  }
  //#endregion
  protected validatefactoryQuoteForm(): boolean {
    let isValid = true;
    const controls = this.factoryQuoteRequest.controls;
    if (this.factoryQuote.isReceiveEmailChecked) {
      if (controls.email.value) {
        const res = this.helperService.isEmailFormatValid(controls.email.value);
        if (!res) {
          this.factoryQuote.isEmailFormatInValid = true;
          this.factoryQuote.isInvalidEmail = true;
          isValid = false;
        } else {
          this.factoryQuote.isEmailFormatInValid = false;
          this.factoryQuote.isInvalidEmail = false;
        }

      } else {
        this.factoryQuote.isInvalidEmail = true;
        isValid = false;
      }
      if (controls.confirmEmail.value) {
        if (controls.confirmEmail.value != controls.email.value) {
          this.factoryQuote.isInvalidConfirmEmail = true;
          this.factoryQuote.isemailNotMatched = true;
          isValid = false;
        }
        else {
          this.factoryQuote.isInvalidConfirmEmail = false;
          this.factoryQuote.isemailNotMatched = false;
        }

      } else {
        this.factoryQuote.isInvalidConfirmEmail = true;
        this.factoryQuote.isemailNotMatched = false;
        isValid = false;
      }
    }
    return isValid;
  }

  confirmWindowClose() {
    this.confirmWindowOpened = false;
  }
  //#region  request quote form dropdown data binding method
  getProductType: MasterData[];
  getInfill: MasterData[];
  getFinishType: MasterData[];
  getGlazing: MasterData[];
  getMuntins: MasterData[];
  MutinsDefaultValue: MasterData;
  getColor: MasterData[];
  getPaintFinish: MasterData[];
  getGlassSupplier: MasterData[];
  getScreens: MasterData[];
  getMesh: MasterData[];
  getHardware: MasterData[];
  getAnodizeColor: MasterData[];

  bindDropdownData() {
    this.quoteService.requestAFactoryQuotePayload().subscribe((response) => {
      if (response) {
        console.log(JSON.stringify(response));
        this.getProductType = response.productTypes;
        this.getInfill = response.infills;
        this.getFinishType = response.finishTypes;
        this.getGlazing = response.glazing;
        this.getMuntins = response.muntins;
        this.MutinsDefaultValue = response.muntins[0];
        this.getColor = response.color;
        this.getPaintFinish = response.paintFinish;
        this.getGlassSupplier = response.glassSupplier;
        this.getScreens = response.screens;
        this.getMesh = response.mesh;
        this.getHardware = response.hardware;
        this.getAnodizeColor = response.anodizeColor;
      } else {
        //do something
      }
    })
  }
  //#endregion

  //#region dropdown change methods

  //hide show variable declaration
  public defaultItem: MasterData = { name: 'Select item...', value: null, checked: true };
  public isProductTypeSelected = false;
  public isFinishTypeSelected = false;
  public isAnodizeFinishTypeSelected = false;
  public isGlazedSelected = false;
  public isGlassSupplierSelected = false;
  public isScreensSelected = false;
  public isMeshSelected = false;
  public isHardwareSelected = false;
  public isPaint22ColorSelected = false;
  public isPaintOtherColorSelected = false;
  public isHardwareOptionalInputSelected = false;
  // methods to make glass supplier dropdown visible

  selectGlazing(event) {
    if (event.value == "Glazed") {//Need to put appropriate condition here
      this.isGlazedSelected = true;
    } else {
      this.isGlazedSelected = false;
      this.isGlassSupplierSelected = false;
    }
  }

  // method to make glass spec makeup input field visible
  selectGlassSupplier(event) {
    if (event.value == "Kawneer") {//Need to put appropriate condition here
      this.isGlassSupplierSelected = true;
    } else {
      this.isGlassSupplierSelected = false;
    }
  }

  // method to make screens and hardware dropdown visible
  selectProductType(event) {
    //Need to put appropriate condition here
    this.isProductTypeSelected = true;
    if (event.value == '8410TL' || event.value == null) {
      this.isProductTypeSelected = false;
    }
    else if (event.value == '8430TL') {
      this.factoryQuote.productTypeDescription =
        "*For 8430TL Single Hung windows, Standard Hardware is Heavy duty balances & sweep locks.";
    }
    else if (event.value == '8450TL') {
      this.factoryQuote.productTypeDescription =
        "*For 8450TL Double Hung windows, Standard Hardware is Heavy duty balances, sweep locks and auto lock @ upper sash.";
    }
    else if (event.value == '8470TL') {
      this.factoryQuote.productTypeDescription =
        "*For 8470TL Sliding windows, Standard Hardware will be: Stainless steel rollers and sweep locks.";
    }
    else if (event.value == 'AA3350') {
      this.factoryQuote.productTypeDescription =
        "*For all vents in the AA3350 series, Standard Hardware is Single Hung - Class 5 Spiral Balances & Sweep Locks and "
        + " Double Hung - Class 5 Spiral Balances, Sweep Locks & Auto Lock @ Upper Sash.";
    }
    else if (event.value == 'AA900') {
      this.factoryQuote.productTypeDescription =
        "*For all vents in the AA900 series, Standard Hardware is 4-bar hinges & single handle multi-point lock.";
    }
    else if (event.value == '8470TL') {
      this.factoryQuote.productTypeDescription =
        "*For 8470TL Sliding windows, Standard Hardware will be: Stainless steel rollers and sweep locks.";
    }
    else {
      this.factoryQuote.productTypeDescription = "*Standard Hardware will be: 4-bar hinges and cam locks.";
    }
  }

  // method to make color dropdown visible
  selectFinishType(event) {
    if (event.value != null && event.value == 'Paint') {
      this.isFinishTypeSelected = true;
      this.isAnodizeFinishTypeSelected = false;
    }
    else if (event.value != null && event.value == 'Anodize') {
      this.isPaint22ColorSelected = false;
      this.isPaintOtherColorSelected = false;
      this.isFinishTypeSelected = false;
      this.isAnodizeFinishTypeSelected = true;
    }
    else {
      this.isPaint22ColorSelected = false;
      this.isPaintOtherColorSelected = false;
      this.isFinishTypeSelected = false;
      this.isAnodizeFinishTypeSelected = false;
    }
  }

  // method to make mesh dropdown visible
  selectScreens(event) {
    if (event.value != "None") {//Need to put appropriate condition here
      this.isScreensSelected = true;
    } else {
      this.isScreensSelected = false;
      this.isMeshSelected = false;
    }
  }

  // method to make 'specify mesh type' input visible
  selectMesh(event) {
    if (event.value == "Other") {//Need to put appropriate condition here
      this.isMeshSelected = true;
    } else {
      this.isMeshSelected = false;
    }
  }

  // method to make 'specify hardware' input visible
  selectHardware(event) {
    if (event.value == "Optional") {//Need to put appropriate condition here
      this.isHardwareOptionalInputSelected = true;
      this.isHardwareSelected = false;
    } else if (event.value == "Custom") {//Need to put appropriate condition here
      this.isHardwareOptionalInputSelected = false;
      this.isHardwareSelected = true;
    } else {
      this.isHardwareSelected = false;
      this.isHardwareOptionalInputSelected = false;
    }
  }

  // method to make paint finish dropdown visible
  selectPaintColor(event) {
    if (event.value == "BW") {
      this.isPaint22ColorSelected = false;
      this.isPaintOtherColorSelected = false;
    }
    else if (event.value == "Others") {
      this.isPaint22ColorSelected = false;
      this.isPaintOtherColorSelected = true;
    }
    else if (event.value != null) {//Need to put appropriate condition here
      this.isPaint22ColorSelected = true;
      this.isPaintOtherColorSelected = false;
    } else {
      this.isPaint22ColorSelected = false;
      this.isPaintOtherColorSelected = false;
    }

    // if (true) {//Need to put appropriate condition here
    //   this.isPaintOtherColorSelected = true;
    // } else {
    //   this.isPaintOtherColorSelected = false;
    // }
  }
  //#endregion
  //#region Set min date to after 3 business day
  public minDate = new Date();
  public minimumDate = (): Date => {
    var todaysDate = new Date();
    this.minDate.setDate(todaysDate.getDate() + 3);
    var day = todaysDate.getDay();
    if (day == 6) {
      this.minDate.setDate(this.minDate.getDate() + 1);
    }
    else if (day == 5 || day == 4) {
      this.minDate.setDate(this.minDate.getDate() + 2);
    }
    return new Date(this.minDate.getFullYear(), this.minDate.getMonth() + 1, this.minDate.getDate());
  }
  //#endregion
  fileSelected(evt) {
    evt.files.forEach(function (file) {
      if (this.uploadedfileNames.indexOf(file.name) === -1) {
        this.uploadedfileNames.push(file.name);
      }
    }.bind(this));
    this.saveInProcess = true;
  }
  uploadSuccess(evt: SuccessEvent) {
    this.uploadedPathForQuoteFile.push(evt.response.body.paths[0]);
  }
  uploadComplete() {
    this.saveInProcess = false;
  }
  emailLeave() {
    const controls = this.factoryQuoteRequest.controls;
    if (controls.email.value) {
      const res = this.helperService.isEmailFormatValid(controls.email.value);
      if (!res) {
        this.factoryQuote.isEmailFormatInValid = true;
        this.factoryQuote.isInvalidEmail = true;

      } else {
        this.factoryQuote.isEmailFormatInValid = false;
        this.factoryQuote.isInvalidEmail = false;
      }

    } else {
      if (this.factoryQuote.isSubmitted) {
        this.factoryQuote.isEmailFormatInValid = false;
        this.factoryQuote.isInvalidEmail = true;
      }
    }
  }
  confirmEmailLeave() {
    const controls = this.factoryQuoteRequest.controls;
    if (controls.confirmEmail.value) {
      if (controls.email.value) {
        if (controls.confirmEmail.value != controls.email.value) {
          this.factoryQuote.isInvalidConfirmEmail = true;
          this.factoryQuote.isemailNotMatched = true;
        }
        else {
          this.factoryQuote.isInvalidConfirmEmail = false;
          this.factoryQuote.isemailNotMatched = false;
        }
      }
    } else {
      if (this.factoryQuote.isSubmitted) {
        this.factoryQuote.isInvalidConfirmEmail = true;
        this.factoryQuote.isemailNotMatched = false;
      }
    }
  }
}
